import { render, staticRenderFns } from "./PublicAncestrylineConfirmation.vue?vue&type=template&id=0ba52ace&scoped=true&"
import script from "./PublicAncestrylineConfirmation.vue?vue&type=script&lang=js&"
export * from "./PublicAncestrylineConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PublicAncestrylineConfirmation.vue?vue&type=style&index=0&id=0ba52ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba52ace",
  null
  
)

export default component.exports